import { DownloadOutlined } from '@ant-design/icons';
import { debounce } from 'lodash';
import { useEffect, useState } from 'react';
import { message } from 'antd';

import { Button, SearchInput } from '../../../../components/index';
import { useChangePagination } from '../../../../hooks';
import { useLazyExportReportsQuery } from '../../../../services/exportApi';
import {
  useGetStopoverGroupbyOperatorQuery,
  useGetStopoversGroupbyOperatorQuery,
} from '../../../../services/stopoverApi';
import {
  StopoverGroupByOperatorType,
  StopoversGroupByOperatorType,
} from '../../../../types';
import { SectionHeader } from '../styles';
import { OperationReportDrawer } from './operationReportDrawer/OperationReportDrawer';
import { OperationsTable } from './operationsTable';

export function OperationsSection() {
  const { onChangePagination, queryPage, setQueryPage } = useChangePagination();
  const PAGE_SIZE = 10;

  const [searchTerm, setSearchTerm] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const [detailFilter, setDetailFilter] = useState({});

  const [exportOperationsReport, { isLoading: isExporting }] =
    useLazyExportReportsQuery();

  const { data: stopoveresData, isFetching: isFetchingStopoveresData } =
    useGetStopoversGroupbyOperatorQuery({
      page: onChangePagination(),
      page_size: PAGE_SIZE,
      report_filter: searchTerm,
    });

  const { data: stopoverData, isFetching: isFetchingStopoverData } =
    useGetStopoverGroupbyOperatorQuery(detailFilter);

  useEffect(() => {
    if (stopoverData?.id) setIsVisible(true);
  }, [stopoverData]);

  function handleFilterChange(term: string) {
    setQueryPage(1);
    setSearchTerm(term);
  }

  function onSelectItem(stopover: StopoversGroupByOperatorType) {
    if (stopover?.id) {
      setDetailFilter({
        ...{ detail_filter_operation_id: stopover.id },
        ...(stopover.operator && {
          detail_filter_operator: stopover.operator,
        }),
        ...(stopover.product_group && {
          detail_filter_product_group: stopover.product_group,
        }),
      });
    }
  }

  function onCloseDrawer() {
    setDetailFilter({});
    setIsVisible(false);
  }

  async function handleExport() {
    try {
      await exportOperationsReport({
        exportType: 'operations',
        params: { search: searchTerm },
      }).unwrap();
      message.success(
        'Exportação em processamento. Você a receberá em seu e-mail em breve.',
        5
      );
    } catch (error) {
      message.error('Erro ao solicitar a exportação. Tente novamente.');
    }
  }

  return (
    <>
      <SectionHeader>
        <SearchInput
          size="large"
          allowClear
          placeholder="Pesquisar embarcação / código  da operação"
          style={{ width: '400px' }}
          onChange={debounce(
            (evt) => handleFilterChange(evt.target.value),
            500
          )}
        />
        <Button
          icon={<DownloadOutlined />}
          size="large"
          onClick={handleExport}
          loading={isExporting}
          style={{ marginLeft: 'auto' }}
        >
          Exportar XLS
        </Button>
      </SectionHeader>
      <OperationsTable
        dataSource={stopoveresData?.results || []}
        onChangePagination={onChangePagination}
        total={stopoveresData?.count}
        isLoading={isFetchingStopoveresData}
        queryPage={queryPage}
        showSizeChanger={false}
        itemsPerPage={PAGE_SIZE}
        pageSize={PAGE_SIZE}
        onSelectItem={onSelectItem}
      />
      <OperationReportDrawer
        isVisible={isVisible}
        onClose={onCloseDrawer}
        stopover={stopoverData || ({} as StopoverGroupByOperatorType)}
      />
    </>
  );
}
